"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _clsx = _interopRequireDefault(require("clsx"));
var _nukaCarousel = _interopRequireDefault(require("nuka-carousel"));
var _styles = require("@material-ui/core/styles");
var _lab = require("@material-ui/lab");
var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));
var _KeyboardArrowLeft = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowLeft"));
var _KeyboardArrowRight = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowRight"));
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _Truncate = _interopRequireDefault(require("../Truncate"));
var _LinkWrapper = _interopRequireDefault(require("../RelatedContentCard/LinkWrapper"));
var _graphqlTypes = require("../_types/graphql-types");
var _envUtils = require("../_utils/env-utils");
var _getProductsListUtils = require("../_utils/getProductsListUtils");
var _HeroProductVariation = _interopRequireDefault(require("./HeroProductVariation"));
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _link;
  return {
    heading: {
      marginBottom: "".concat(theme.spacing(5), "px !important"),
      marginTop: '0 !important',
      textTransform: 'uppercase'
    },
    itemWrapper: {
      '&:focus': {
        outline: 'none'
      }
    },
    itemTitle: {
      display: 'inline-block',
      fontSize: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightMedium,
      margin: '0',
      color: theme.palette.secondary.main,
      wordBreak: 'break-word',
      '& p': {
        marginBottom: 0
      }
    },
    itemDescription: {
      wordBreak: 'break-word',
      '& p': {
        marginBottom: 0
      }
    },
    leftNavButton: {
      left: '-30px'
    },
    rightNavButton: {
      right: '-30px'
    },
    navArrow: {
      fontSize: theme.typography.pxToRem(28),
      color: theme.palette.secondary.main
    },
    navArrowDisabled: {
      color: theme.palette.text.disabled
    },
    anchorColor: {
      color: theme.palette.secondary.main
    },
    imageHeight: {
      position: 'relative',
      overflow: 'hidden',
      background: 'transparent',
      height: 0,
      paddingBottom: '60.7%',
      // ideal size of 290x176
      marginBottom: theme.spacing(3)
    },
    imgResponsive: {
      width: '100%',
      position: 'absolute',
      top: '50%',
      transform: 'translate(0, -50%)',
      objectFit: 'cover'
    },
    error: {
      padding: theme.spacing(6, 5, 3),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center'
    },
    noProductCarouselError: {
      padding: theme.spacing(6, 5, 3),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      color: theme.palette.error.main,
      marginTop: 40
    },
    text: (0, _defineProperty2.default)({
      lineHeight: theme.typography.pxToRem(16),
      fontSize: theme.typography.pxToRem(14),
      display: 'block'
    }, theme.breakpoints.up('md'), {
      lineHeight: theme.typography.pxToRem(22),
      paddingTop: theme.spacing(1),
      fontSize: theme.typography.pxToRem(16)
    }),
    link: (_link = {
      color: 'inherit',
      fontSize: theme.typography.pxToRem(14),
      marginBottom: theme.spacing(0)
    }, (0, _defineProperty2.default)(_link, theme.breakpoints.up('md'), {
      fontSize: theme.typography.pxToRem(16),
      marginBottom: theme.spacing(0.5)
    }), (0, _defineProperty2.default)(_link, "fontWeight", theme.typography.fontWeightBold), _link),
    cardElement: {
      display: 'flex',
      margin: 0,
      '& figcaption': {
        color: theme.palette.common.black,
        marginLeft: '1.5rem',
        fontWeight: theme.typography.fontWeightMedium,
        '& p': {
          marginBottom: 0
        }
      }
    },
    mainContentImage: {
      flexShrink: 0,
      width: '88px',
      border: "1px solid ".concat(theme.palette.grey[400]),
      height: '88px',
      overflow: 'hidden',
      textAlign: 'center',
      borderRadius: '4px',
      backgroundColor: theme.palette.common.white,
      display: 'inline-flex',
      '& > img': {
        width: '100%',
        objectFit: 'contain'
      }
    },
    productNameP: {
      fontSize: '0.75rem',
      fontWeight: theme.typography.fontWeightMedium,
      lineHeight: '1.25'
    },
    productNumP: {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightBold,
      '& + span': {
        fontWeight: theme.typography.fontWeightMedium
      }
    },
    btnWrap: {
      marginTop: '1.5rem',
      '& button': {
        width: '100%',
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: '1rem'
      }
    },
    heroProductVWrapper: {
      background: theme.palette.common.white,
      borderRadius: theme.typography.pxToRem(5),
      border: "solid 1px ".concat(theme.palette.grey[300]),
      padding: "".concat(theme.spacing(8, 6), " !important"),
      height: 365,
      '.aem-GridColumn.aem-GridColumn--default--12 > &': {
        maxWidth: '50%'
      },
      '& > h3': {
        marginBottom: "".concat(theme.spacing(10), "px !important"),
        fontSize: theme.typography.pxToRem(18),
        textTransform: 'unset'
      },
      '& .slide > div': {
        padding: theme.spacing(0, 1)
      }
    },
    viewAll: {
      fontSize: theme.typography.pxToRem(16),
      display: 'inline-block',
      marginTop: theme.spacing(15)
    }
  };
});
var RelatedComponentConfig = {
  emptyLabel: 'Configure Related Products',
  isEmpty: function isEmpty(props) {
    if (props.products.length > 0) {
      return false;
    } else {
      return true;
    }
  }
};
var RelatedProducts = function RelatedProducts(_ref) {
  var title = _ref.title,
    products = _ref.products,
    cardsPerRotation = _ref.cardsPerRotation,
    _ref$autoplay = _ref.autoplay,
    autoplay = _ref$autoplay === void 0 ? false : _ref$autoplay,
    delay = _ref.delay,
    arialabel = _ref.arialabel,
    autopauseDisabled = _ref.autopauseDisabled,
    hideProductImg = _ref.hideProductImg,
    hideProductDesc = _ref.hideProductDesc,
    anchorId = _ref.anchorId,
    _ref$externalLinks = _ref.externalLinks,
    externalLinks = _ref$externalLinks === void 0 ? [] : _ref$externalLinks,
    totalCards = _ref.totalCards,
    viewAllCTALink = _ref.viewAllCTALink,
    viewAllText = _ref.viewAllText,
    cardType = _ref.cardType;
  /**
   * Sets isProductHeroCard to true when the author selects "Hero Product Card" option
   * while configuring the related Products component.
   */
  var isProductHeroCard = cardType === 'hero';
  var classes = useStyles();
  var theme = (0, _styles.useTheme)();
  var mediaQueryMdUp = (0, _useMediaQuery.default)(theme.breakpoints.up('md'));
  var SlideToShowNumber = 1;
  var IMAGE_HOST = (0, _envUtils.getProductImageHost)();
  var getFallbackImg = function getFallbackImg(brand) {
    var imgUrl;
    switch (brand) {
      case 'SIGMA':
        imgUrl = "".concat(IMAGE_HOST, "/deepweb/assets/sigmaaldrich/marketing/global/images/default/default-gemeric-sigmaaldrich/default-gemeric-sigmaaldrich_w300.png");
        break;
      case 'MILLIPORE':
        imgUrl = "".concat(IMAGE_HOST, "/deepweb/assets/sigmaaldrich/marketing/global/images/default/default-gemeric-millipore/default-gemeric-millipore_w300.png");
        break;
      case 'MILLIQ':
        imgUrl = "".concat(IMAGE_HOST, "/deepweb/assets/sigmaaldrich/marketing/global/images/default/default-gemeric-milliq/default-gemeric-milliq_w300.png");
        break;
      case 'SAFC':
        imgUrl = "".concat(IMAGE_HOST, "/deepweb/assets/sigmaaldrich/marketing/global/images/default/default-gemeric-safc/default-gemeric-safc_w300.png");
        break;
      case 'SUPELCO':
        imgUrl = "".concat(IMAGE_HOST, "/deepweb/assets/sigmaaldrich/marketing/global/images/default/default-gemeric-supelco/default-gemeric-supelco_w300.png");
        break;
      case 'BIORELIANCE':
        imgUrl = "".concat(IMAGE_HOST, "/deepweb/assets/sigmaaldrich/marketing/global/images/default/default-gemeric-bioreliance/default-gemeric-bioreliance.png");
        break;
      default:
        imgUrl = "".concat(IMAGE_HOST, "/deepweb/assets/sigmaaldrich/marketing/global/images/default/default-gemeric-default/default-gemeric-default_w300.png");
    }
    return imgUrl;
  };
  if (mediaQueryMdUp) {
    SlideToShowNumber = cardsPerRotation;
  }
  var updatedProductInputs = (0, _getProductsListUtils.getUpdatedInputsBasedOnCatalogType)(products);
  var productInputs = updatedProductInputs === null || updatedProductInputs === void 0 ? void 0 : updatedProductInputs.map(function (_ref2) {
    var brandKey = _ref2.brandKey,
      productKey = _ref2.productKey,
      catalogType = _ref2.catalogType;
    return {
      brandKey: brandKey,
      productKey: productKey,
      catalogType: catalogType
    };
  });
  var _useMultipleProductDe = (0, _graphqlTypes.useMultipleProductDetailPartialProductsQuery)({
      variables: {
        productInputs: productInputs
      },
      errorPolicy: 'ignore',
      ssr: false
      //client
    }),
    loading = _useMultipleProductDe.loading,
    error = _useMultipleProductDe.error,
    data = _useMultipleProductDe.data;
  if (loading) {
    return __jsx("div", {
      id: anchorId
    }, __jsx(_lab.Skeleton, {
      width: "100%",
      variant: "rect",
      height: 150,
      animation: "wave"
    }), __jsx(_lab.Skeleton, {
      width: "50%"
    }), __jsx(_lab.Skeleton, {
      width: "50%"
    }));
  }
  if (error) {
    console.error(error);
    if (products.length > 0 && !window.location.href.includes('.content.')) {
      return __jsx("div", {
        id: anchorId,
        className: classes.error
      }, __jsx(_Error.default, null), __jsx("span", null, "Something went wrong, please try again."));
    } else {
      return null;
    }
  } else {
    var relatedProductData = data ? data.getMultipleProductDetails.filter(Boolean) : [];
    var maxRelatedProductCount = totalCards - externalLinks.length;
    var numberCards = Math.min(totalCards, relatedProductData.length + externalLinks.length);
    var isViewAllPresent = mediaQueryMdUp && isProductHeroCard && !!viewAllCTALink && !!viewAllText;
    return __jsx("div", {
      id: anchorId,
      "aria-label": arialabel,
      className: 'aem-ms-cmp aem-ms-related-products' + (isProductHeroCard ? ' ' + (0, _clsx.default)(classes.heroProductVWrapper) : '')
    }, title && relatedProductData.length > 0 && __jsx("h3", {
      className: classes.heading,
      dangerouslySetInnerHTML: {
        __html: title.slice(0, 90)
      }
    }), relatedProductData.length || externalLinks.length ? __jsx("div", null, isProductHeroCard ? __jsx(_HeroProductVariation.default, {
      arialabel: arialabel,
      autoplay: autoplay,
      delay: delay,
      autopauseDisabled: !autopauseDisabled,
      relatedProductData: relatedProductData,
      maxRelatedProductCount: maxRelatedProductCount,
      hideProductImg: hideProductImg,
      IMAGE_HOST: IMAGE_HOST,
      externalLinks: externalLinks,
      PRODUCT_IMAGE_FALLBACK: _envUtils.PRODUCT_IMAGE_FALLBACK,
      getFallbackImg: getFallbackImg,
      hideProductDesc: hideProductDesc,
      totalCards: totalCards
    }) : __jsx(_nukaCarousel.default, {
      "aria-label": arialabel,
      cellSpacing: 32,
      autoplay: autoplay,
      autoplayInterval: delay,
      pauseOnHover: !autopauseDisabled,
      slidesToShow: SlideToShowNumber,
      slidesToScroll: SlideToShowNumber,
      renderCenterLeftControls: function renderCenterLeftControls(props) {
        var disabled = props.currentSlide === 0;
        return numberCards > cardsPerRotation ? __jsx(_core.ButtonBase, {
          className: classes.leftNavButton,
          disabled: disabled,
          onClick: function onClick() {
            return props.previousSlide();
          },
          "aria-label": "previous"
        }, __jsx(_KeyboardArrowLeft.default, {
          className: (0, _clsx.default)(classes.navArrow, disabled && classes.navArrowDisabled)
        })) : null;
      },
      renderBottomCenterControls: null,
      renderCenterRightControls: function renderCenterRightControls(props) {
        var disabled = props.currentSlide + props.slidesToShow === props.slideCount || props.slideCount < props.slidesToShow;
        return numberCards > cardsPerRotation ? __jsx(_core.ButtonBase, {
          className: classes.rightNavButton,
          disabled: disabled,
          onClick: function onClick() {
            return props.nextSlide();
          },
          "aria-label": "next"
        }, __jsx(_KeyboardArrowRight.default, {
          className: (0, _clsx.default)(classes.navArrow, props.slidesToScroll && disabled && classes.navArrowDisabled)
        })) : null;
      }
    }, relatedProductData.slice(0, maxRelatedProductCount).map(function (product, index) {
      var _product$brand;
      var productName = __jsx("span", {
        dangerouslySetInnerHTML: {
          __html: product.name
        }
      });
      var brandName = __jsx("span", {
        dangerouslySetInnerHTML: {
          __html: product === null || product === void 0 ? void 0 : (_product$brand = product.brand) === null || _product$brand === void 0 ? void 0 : _product$brand.name
        }
      });
      // Removing fallback as per STRAT-17307
      // Todo: add a description fallback for author view
      return __jsx("div", {
        key: index,
        className: classes.itemWrapper
      }, __jsx(_react.default.Fragment, null, __jsx(_LinkWrapper.default, {
        href: '/product/' + product.brand.key + '/' + product.productNumber
      }, __jsx("figure", {
        className: classes.cardElement
      }, !hideProductImg && __jsx("div", {
        className: classes.mainContentImage
      }, __jsx("img", {
        src: product.images[0].mediumUrl ? "".concat(IMAGE_HOST).concat(product.images[0].mediumUrl) : product.defaultSrc ? product.defaultSrc : getFallbackImg(product.brand.key),
        onError: function onError(e) {
          ;
          e.target.src = _envUtils.PRODUCT_IMAGE_FALLBACK;
        },
        alt: product.images[0].altText,
        title: product.images[0].altText
      })), __jsx("figcaption", null, brandName && __jsx(_core.Typography, {
        className: classes.productNameP
      }, brandName), (product === null || product === void 0 ? void 0 : product.productNumber) && __jsx(_core.Typography, {
        className: classes.productNumP
      }, product === null || product === void 0 ? void 0 : product.productNumber), productName && __jsx(_Truncate.default, {
        lines: 2
      }, productName)))), __jsx("div", {
        className: classes.btnWrap
      }, __jsx(_core.Button, {
        onClick: function onClick() {
          return alert('Pricing not available in Authoring Environment');
        },
        variant: "outlined",
        color: "primary"
      }, "View Price and Availability"))));
    }), externalLinks.length > 0 && externalLinks.map(function (extItem, index) {
      return __jsx("div", {
        key: index,
        className: classes.itemWrapper
      }, !hideProductImg && __jsx("div", {
        className: classes.imageHeight
      }, __jsx(_LinkWrapper.default, {
        href: extItem.url,
        externalUrl: extItem.url[0] !== '/'
      }, __jsx("img", {
        src: extItem.src,
        onError: function onError(e) {
          ;
          e.target.src = _envUtils.PRODUCT_IMAGE_FALLBACK;
        },
        className: classes.imgResponsive,
        alt: extItem.altText || extItem.text,
        title: extItem.text
      }))), extItem.title && __jsx(_LinkWrapper.default, {
        href: extItem.url,
        className: classes.itemTitle,
        externalUrl: extItem.url[0] !== '/'
      }, __jsx(_Truncate.default, {
        lines: 2
      }, __jsx(_core.Typography, {
        component: "span",
        className: classes.link,
        dangerouslySetInnerHTML: {
          __html: extItem.title
        }
      }))), !hideProductDesc && __jsx("div", {
        className: classes.itemDescription
      }, extItem.text && __jsx(_Truncate.default, {
        lines: 5
      }, __jsx(_core.Typography, {
        component: "span",
        className: classes.text,
        dangerouslySetInnerHTML: {
          __html: extItem.text
        }
      }))));
    })), isViewAllPresent && __jsx("a", {
      className: classes.viewAll,
      href: viewAllCTALink || ''
    }, viewAllText)) : null, cardType === 'default' && relatedProductData.length < 1 && __jsx("div", {
      id: anchorId,
      className: classes.noProductCarouselError
    }, __jsx(_Error.default, null), __jsx("span", null, "Please add the products to carousel.")));
  }
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/relatedproducts')(RelatedProducts, RelatedComponentConfig);
exports.default = _default;